<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>OneLynk Services</h1>
<main class="services-main">
  <div class="instruction-text" style="margin-bottom:20px;">OneLynk offers a wide variety of services to help you manage your
    business.
  </div>
<section style="border:none;max-width:1000px;">
  <p-accordion class="service-accord" [activeIndex]="activeIndex">
    <p-accordionTab *ngIf="user.hasRole[Roles.ESS]" header="Employee Self-Service" class="service-ess" icon="fa fa-user">

      <h5>ESS provides ability manage your employee information, submit requests, and select benefits.
        Please contact your Account Manager.</h5>

      <h5>Manage employee information, forms, and requests.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="RouteLink.Profile" routerLinkActive="active">My Profile</a>
          </h3>Manage your employee information.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.SelfAppraisal" routerLinkActive="active">Self-Appraisal</a>
          </h3>Complete your self-appraisal for performance reviews.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.LeaveRequest" routerLinkActive="active">Leave Request</a>
          </h3>Create and manage requests for leave/PTO.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.QualifyingLifeEvent" routerLinkActive="active">Qualifying Life Event</a>
          </h3>Create and manage Qualifying Life Events.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.BenefitSelection" routerLinkActive="active">Benefit Selection</a>
          </h3>Review and select benefit options.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.VacationRequest" routerLinkActive="active">Vacation Request</a>
          </h3>Create and manage requests for vacation time.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.WorkAuthSummary" routerLinkActive="active">Work Authorization</a>
          </h3>Mangage your project work authorization.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.TrainingRequest" routerLinkActive="active">Training Request</a>
          </h3>Create and manage requests for training activities.
        </li>



      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>

    <p-accordionTab *ngIf="user.hasRole[Roles.MSS]" header="Manager Self-Service" class="service-mss">
      <h5>Manage team information, forms, and requests.</h5>
      <ul *ngIf="user.hasRole[Roles.MSS]">
        <li>
          <h3>
            <a [routerLink]="RouteLink.EmployeeChangeRequest" routerLinkActive="active">Employee Changes</a>
          </h3>Manage your employees.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.EmployeeLeaveHistory" routerLinkActive="active">Employee Leave History</a>
          </h3>View your employee leave history.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.RecruitToHire" routerLinkActive="active">Recruit-to-Hire</a>
          </h3>Create and manage job requisitions.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.EmployeeAppraisal" routerLinkActive="active">Employee Appraisal</a>
          </h3>Complete your employee appraisals for performance reviews.
        </li>
      </ul>

      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab *ngIf="user.hasRole[Roles.HrGeneralist]" header="Human Capital Management" class="service-hcm">
      <h5>Manage personnel, benefits, policies, and organization.</h5>
      <ul *ngIf="user.hasRole[Roles.HrGeneralist]">
        <li>
          <h3>
            <a [routerLink]="RouteLink.ResourceManagement" routerLinkActive="active">Resource Management</a>
          </h3>Manage your organization's employee information.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.AppraisalAdmin" routerLinkActive="active">Appraisal Setup</a>
          </h3>Setup and manage your appraisal process for performance reviews.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.BenefitProvider" routerLinkActive="active">Benefits</a>
          </h3>Maintain your benefit providers.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.EmployeeClass" routerLinkActive="active">Employee Class</a>
          </h3>Define and manage your organization's employee classes.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.JobPostingSite" routerLinkActive="active">Job Posting Site</a>
          </h3>Define and manage your organization's job posting sites.
        </li>
        <li>
          <h3>
            <a [routerLink]="[RouteLink.WageDeterminationSummary]" routerLinkActive="active">Wage Determinations</a>
          </h3>Create and manage WDs.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.OfferLetter" routerLinkActive="active">Offer Letters</a>
          </h3>Define and manage your organization's offer letters to candidates.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.OfferLetterClause" routerLinkActive="active">Offer Letter Clauses</a>
          </h3>Define and manage your organization's offer letters clauses based on employee class.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.Position" routerLinkActive="active">Positions</a>
          </h3>Define and manage your organization's position grade.
        </li>        <li>
          <h3>
            <a [routerLink]="RouteLink.PositionGrade" routerLinkActive="active">Position Grade</a>
          </h3>Define and manage your organization's position grade.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.PtoPolicy" routerLinkActive="active">PTO Policies</a>
          </h3>Define and manage your organizations' PTO and leave policies.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.ScreeningQuestion" routerLinkActive="active">Screening Questions</a>
          </h3>Define and manage your organization's candidate screening question.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.ScreeningQuestionCategory" routerLinkActive="active">Screening Categories</a>
          </h3>Define and manage your organization's candidate screening question category.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.RecruitToHire" routerLinkActive="active">Recruit-to-Hire</a>
          </h3>Create and manage job requisitions.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.VirtualOrientation" routerLinkActive="active">Virtual Orientation</a>
          </h3>Manage the virtual orientation process for new hires.
        </li>
        <li *ngIf="user.hasRole[Roles.HcmDashboard]">
          <h3>
          <a (click)="qlikPunchOut(QlikAppName.Hcm)" routerLinkActive="active">People Dashboard</a>
          </h3> Advanced analytics dashboard about employee retention, recruiting & hiring, and employee performance.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.EmployeeOffboardingChecklist" routerLinkActive="active">Termination Checklist</a>
          </h3>Manage termination activities for employees.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab *ngIf="user.hasRole[Roles.FinanceTimesheet] || user.hasRole[Roles.FinanceExpense] || user.hasRole[Roles.FinanceTimesheetAdmin]"  header="Time &amp; Expense"
                    class="service-time">
      <h5>Manage timesheets and expense reports.</h5>
      <ul *ngIf="user.hasRole[Roles.FinanceTimesheet] || user.hasRole[Roles.FinanceExpense] || user.hasRole[Roles.FinanceTimesheetAdmin]">
        <li *ngIf="user.hasRole[Roles.FinanceTimesheet]">
          <h3>
            <a [routerLink]="RouteLink.Timesheet" routerLinkActive="active">My Timesheet</a>
          </h3>Review and submit your timesheet information.
        </li>
        <li *ngIf="user.hasRole[Roles.MSS]">
          <h3>
            <a [routerLink]="RouteLink.TimesheetManager" routerLinkActive="active">Employee Timesheets</a>
          </h3>Review and approve your employees' timesheets.
        </li>
        <li *ngIf="user.hasRole[Roles.FinanceTimesheetAdmin]">
          <h3>
            <a [routerLink]="RouteLink.TimesheetAdmin" routerLinkActive="active">Timesheet Admin</a>
          </h3>Review and approve your organization's timesheets.
        </li>
        <li *ngIf="user.hasRole[Roles.FinanceExpense]">
          <h3>
            <a [routerLink]="RouteLink.ExpenseReport" routerLinkActive="active">Expense Report</a>
          </h3>View and manage submitted expense reports.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab *ngIf="user.hasRole[Roles.Procurement] || user.hasRole[Roles.ItemCatalogAdmin] || user.hasRole[Roles.AP] || user.hasRole[Roles.ItemReceipt] || user.hasRole[Roles.ItemReturn] ||
    user.hasRole[Roles.MaterialOrder]"
                    header="Procurement" class="service-proc">
      <h5>Manage purchase requisitions and manage trading partners.</h5>
      <ul>
        <li *ngIf="user.hasRole[Roles.Procurement]">
          <h3>
            <a [routerLink]="RouteLink.PurchaseRequisition">Purchase Requisition/PO</a>
          </h3>Create and manage purchase requisitions.
        </li>
        <li *ngIf="user.hasRole[Roles.ItemReceipt]">
          <h3>
            <a [routerLink]="RouteLink.Receipt" routerLinkActive="active">Item Receipt</a>
          </h3>Manage items received by your organization.
        </li>
        <li *ngIf="user.hasRole[Roles.ItemCatalogAdmin]">
          <h3>
            <a [routerLink]="RouteLink.ItemCatalogAdmin" routerLinkActive="active">Item Catalog</a>
          </h3>Maintain item catalogs for creating PRs, POs, and invoices.
        </li>
        <li *ngIf="user.hasRole[Roles.ItemReturn]">
          <h3>
            <a [routerLink]="RouteLink.PurchaseReturn" routerLinkActive="active">Item Return</a>
          </h3>Manage returns for your organization.
        </li>
        <li *ngIf="user.hasRole[Roles.AP]">
          <h3>
            <a [routerLink]="RouteLink.Vendor" routerLinkActive="active">Vendors</a>
          </h3>Manage partners who sell products and services to you.
        </li>
        <li *ngIf="user.hasRole[Roles.MaterialOrder]">
          <h3>
            <a [routerLink]="'/procurement/material-order'" routerLinkActive="active">Material Order</a>
          </h3>Manage material orders for your organization.
        </li>
        <li *ngIf="user.hasRole[Roles.AP]">
          <h3>
            <a [routerLink]="RouteLink.VendorInvoice" routerLinkActive="active">Vendor Bills</a>
          </h3>Manage invoices for your organization.
        </li>
        <li *ngIf="user.hasRole[Roles.ProcurementDashboard]">
          <h3>
          <a (click)="qlikPunchOut(QlikAppName.Procurement)" routerLinkActive="active">Spend Analysis Dashboard</a>
          </h3> View dashboards on procurement activities and identify gaps in spending.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab  *ngIf="user.hasRole[Roles.SalesOrder] || user.hasRole[Roles.PackingSlip] || user.hasRole[Roles.SalesReturn] || user.hasRole[Roles.AR]" header="Orders" class="service-order">
      <h5>Manage orders, pakcing slips, and returns.</h5>
      <ul>
        <li *ngIf="user.hasRole[Roles.SalesOrder]">
          <h3>
            <a [routerLink]="RouteLink.SalesOrder" routerLinkActive="active">Sales Order</a>
          </h3>View and manage Sales Orders in the system.
        </li>
        <li *ngIf="user.hasRole[Roles.PackingSlip]">
          <h3>
            <a [routerLink]="RouteLink.PackingSlip" routerLinkActive="active">Packing Slip</a>
          </h3>View and manage Packing Slips in the system.
        </li>
        <li *ngIf="user.hasRole[Roles.SalesReturn]">
          <h3>
            <a [routerLink]="RouteLink.SalesReturn" routerLinkActive="active">Sales Return</a>
          </h3>View and manage Sales Returns in the system.
        </li>
        <li *ngIf="user.hasRole[Roles.AR]">
          <h3>
            <a [routerLink]="RouteLink.Customer" routerLinkActive="active">Customers</a>
          </h3>Manage partners who buy products and services from you.
        </li>
        <li *ngIf="user.hasRole[Roles.AR]">
          <h3>
            <a [routerLink]="RouteLink.CustomerInvoice" routerLinkActive="active">Customer Invoices</a>
          </h3>View and manage Customer Bills in the system.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab header="Finance " class="service-finance ">
      <h5>Manage payables, receivables, and charge codes.</h5>
      <ul *ngIf="user.hasRole[Roles.AP] || user.hasRole[Roles.AR] || user.hasRole[Roles.ChargeCodeAdmin] || user.hasRole[Roles.ChartOfAccountAdmin] || user.hasRole[Roles.GeneralLedgerAdmin] ||
      user.hasRole[Roles.VoucherRegister]">
        <li *ngIf="user.hasRole[Roles.AP]">
          <h3>
            <a [routerLink]="RouteLink.AccountPayable " routerLinkActive="active">Accounts Payable</a>
          </h3>Review incoming invoices and manage payments to vendors.
        </li>
        <li *ngIf="user.hasRole[Roles.ChargeCodeAdmin]">
          <h3>
            <a [routerLink]="RouteLink.AccountGroup" routerLinkActive="active">Account Groups</a>
          </h3>Manage charge code groups.
        </li>
        <li *ngIf="user.hasRole[Roles.VoucherRegister]" >
          <h3>
            <a [routerLink]="RouteLink.VoucherRegister " routerLinkActive="active">Voucher Register</a>
          </h3>Review payments for your organization.
        </li>
        <li *ngIf="user.hasRole[Roles.ChartOfAccountAdmin]">
          <h3>
            <a [routerLink]="RouteLink.SolMgrChartOfAccountsSetup" routerLinkActive="active">Chart of Accounts</a>
          </h3>View and manage your chart of accounts.
        </li>
        <li *ngIf="user.hasRole[Roles.AR]">
          <h3>
            <a [routerLink]="RouteLink.AccountReceivable " routerLinkActive="active">Accounts Receivable</a>
          </h3>Manage outgoing invoices and manage payments from customers.
        </li>
        <li *ngIf="user.hasRole[Roles.AR]">
          <h3>
            <a [routerLink]="RouteLink.RevenueRecognition " routerLinkActive="active">Revenue Recognition</a>
          </h3>Manage revenue recognition of customer invoices.
        </li>
        <li *ngIf="user.hasRole[Roles.GeneralLedgerAdmin]" >
          <h3>
            <a [routerLink]="RouteLink.GeneralLedger" routerLinkActive="active">General Ledger</a>
          </h3>View and manage your general ledger.
        </li>
        <li *ngIf="user.hasRole[Roles.ChargeCodeAdmin]">
          <h3>
            <a [routerLink]="RouteLink.ChargeCodeAdmin" routerLinkActive="active">Charge Codes</a>
          </h3>Manage charge codes and authorized users.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.FinanceCalendar" routerLinkActive="active">Finance Calendar</a>
          </h3>View and manage your finance calendars.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.FinancialReport" routerLinkActive="active">Financial Report</a>
          </h3>View and manage your financial reports.
        </li>
        <li *ngIf="user.hasRole[Roles.PaymentTermsAdmin]">
          <h3>
            <a [routerLink]="RouteLink.PaymentTermAdmin" routerLinkActive="active">Payment Terms Setup</a>
          </h3>Manage payment terms for your organization.
        </li>
        <li *ngIf="user.hasRole[Roles.FinanceDashboard]">
          <h3>
          <a (click)="qlikPunchOut(QlikAppName.Finance)" routerLinkActive="active">Finance Dashboard</a>
        </h3> Explore dashboards on various financial KPIs, eg.. assets, liabilities, working capital, inventory etc..
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>

    <p-accordionTab *ngIf="user.hasRole[Roles.PayrollAdmin]" header="Payroll " class="service-payroll">
      <h5>Manage payroll, purchasing and invoicing, product and service catalogs.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="RouteLink.Payroll " routerLinkActive="active">Payroll Main</a>
          </h3>Manage payroll, purchasing and invoicing, product and service catalogs.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>

    <p-accordionTab  *ngIf="user.hasRole[Roles.Contract]" header="Bids &amp; Contracts " class="service-contract">
      <h5>Create and maintain bids and contracts.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="['/project/contract-summary', 'bid']" routerLinkActive="active">Bids</a>
          </h3>Create and maintain Bids.
        </li>
        <li>
          <h3>
            <a [routerLink]="['/project/contract-summary', 'contract']" routerLinkActive="active">Contracts</a>
          </h3>Create and maintain Contract.
        </li>
        <li>
          <h3>
            <a [routerLink]="[RouteLink.BillingPlanSummary]" routerLinkActive="active">Default Billing Plan</a>
          </h3>Create and maintain Billing Plan for Contract.
        </li>
        <li>
          <h3>
            <a [routerLink]="[RouteLink.AtRiskRequest]" routerLinkActive="active">At-Risk Request</a>
          </h3>Create and maintain At-Risk Request for Contract.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>

    <p-accordionTab *ngIf="user.hasRole[Roles.Project]" header="Estimates &amp; Projects " class="service-project ">
      <h5>Create and maintain estimates and projects.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="['/project/project-summary', 'estimate']" routerLinkActive="active">Estimates</a>
          </h3>Create and maintain estimates.
        </li>
        <li>
          <h3>
            <a [routerLink]="['/project/project-summary', 'project']" routerLinkActive="active">Projects</a>
          </h3>Create and maintain projects.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.ProjectCatalog" routerLinkActive="active"> Project Catalog</a>
          </h3>Create and maintain project catalog.
        </li>
        <li>
          <h3>
            <a [routerLink]="[RouteLink.BillingPlanSummary]" routerLinkActive="active">Default Billing Plan</a>
          </h3>Create and maintain Billing Plan for Project.
        </li>
        <li>
        <h3>
          <a [routerLink]="[RouteLink.AtRiskRequest]" routerLinkActive="active">At-Risk Request</a>
        </h3>Create and maintain At-Risk Request for Project.
        </li>
        <li *ngIf="user.hasRole[Roles.ProjectContractDashboard]">
          <h3>
          <a (click)="qlikPunchOut(QlikAppName.Project)" routerLinkActive="active"> Project Dashboard</a>
        </h3> See dashboards on Revenue, Profit/Loss, Expense, Funding, Un-billed amount and indirect rate types related to the contract and projects.
        </li>
        <li>
          <h3><a [routerLink]="RouteLink.ProjectStatusReport" routerLinkActive="active">Projects Status Reports</a></h3> View and download project reports by year, department, and accounting period.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>

    <p-accordionTab  *ngIf="user.hasRole[Roles.CyberplanCertifier] || user.hasRole[Roles.CyberplanAssessor] || user.hasRole[Roles.CyberplanRemediator]" header="Security Assessments "
                     class="service-security ">
      <h5>Create and maintain security assessments.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="RouteLink.CyberplanSystemsSummary" routerLinkActive="active">System</a>
          </h3>Maintain systems for security assessments.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.CyberplanSecurityPolicy" routerLinkActive="active">Policy</a>
          </h3>Maintain policies for security assessments.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.CyberplanSecurityThreat" routerLinkActive="active">Threat</a>
          </h3>Maintain threats for security assessments.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>

    <p-accordionTab header="Business Analytics" class="service-reports">
      <h5>View real-time analytics and reports for your organization.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="RouteLink.Reporting" routerLinkActive="active">Reporting</a>
          </h3>Customize, view, and export reports and analytics for your organization.
        </li>
          <li *ngIf="user.hasRole[Roles.ExecutiveDashboard]">
            <h3>
            <a (click)="qlikPunchOut(QlikAppName.Executive)" routerLinkActive="active">Executive Dashboards</a>
        </h3> See Executive dashboards for Finance, People, Spend Analysis, Projects & Contracts.
          </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab *ngIf="user.hasRole[Roles.SupportFile]" header="Support Files" class="service-support-files">
      <!-- adding service-inactive will disable a section and add a Sign Up message-->
      <h5>Upload and share files with other users for onboarding and other supporting needs.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="RouteLink.FileSharingOnboardingFiles" routerLinkActive="active">Customer Onboarding</a>
          </h3>Upload documents for customer onboarding.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.FileSharingMaintenanceFiles" routerLinkActive="active">Supporting Documentation</a>
          </h3>Upload documents for other supporting needs
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
    <p-accordionTab *ngIf="user.hasRole[Roles.OrgAdmin] || user.hasRole[Roles.CSRAdmin]" header="Settings &amp; Solutions" class="service-org">
      <!-- adding service-inactive will disable a section and add a Sign Up message-->
      <h5>Setup and maintain organization settings.</h5>
      <ul>
        <li>
          <h3>
            <a [routerLink]="RouteLink.SolMgrMain" routerLinkActive="active">Solution Manager</a>
          </h3>Setup and maintain organization settings.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.SolMgrOrgSetupValidation" routerLinkActive="active">Run Setup Validations</a>
          </h3>Run organization setup validations.
        </li>
        <li>
          <h3>
            <a [routerLink]="RouteLink.SolMgrTransactionValidation" routerLinkActive="active">Run Transaction Validations</a>
          </h3>Run organization transaction validations.
        </li>
      </ul>
      <h4>For more information, please contact your Account Manager.</h4>
    </p-accordionTab>
  </p-accordion>
</section>
</main>
